import PropTypes from 'prop-types';

import { WzCodeTreeNode } from './WzCodeTreeNode';

/**
 * Renders level-1 sections (A-U) as top-level nodes, recurses via WzCodeTreeNode.
 */
export const WzCodeTree = ({ roots, childrenByParent, selectedSet, expandedSet, onToggleCheck, onToggleExpand }) => {
	if (!roots || roots.length === 0) {
		return <div className="p-4 text-center text-sm text-bgBase-800">Keine Branchendaten verfügbar</div>;
	}

	return (
		<div className="divide-y divide-gray-100">
			{roots.map((root) => (
				<WzCodeTreeNode
					key={root.code}
					node={root}
					childrenByParent={childrenByParent}
					selectedSet={selectedSet}
					expandedSet={expandedSet}
					onToggleCheck={onToggleCheck}
					onToggleExpand={onToggleExpand}
					depth={0}
				/>
			))}
		</div>
	);
};

WzCodeTree.propTypes = {
	roots: PropTypes.array.isRequired,
	childrenByParent: PropTypes.instanceOf(Map).isRequired,
	selectedSet: PropTypes.instanceOf(Set).isRequired,
	expandedSet: PropTypes.instanceOf(Set).isRequired,
	onToggleCheck: PropTypes.func.isRequired,
	onToggleExpand: PropTypes.func.isRequired,
};

export default WzCodeTree;
